import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

import { ApiService } from 'src/app/services/api.service';
import { endpoints } from 'src/app/constants/endpoints';

@Component({
    selector: 'data-cleanse',
    templateUrl: './component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class DataCleanse implements OnInit {
  public form: FormGroup;
  public type: string;

  constructor(
    public dialogRef: MatDialogRef<DataCleanse>,
    protected Api: ApiService
  ) {}

  ngOnInit() {
    const formBuilder = new FormBuilder();

    this.form = formBuilder.group({
      file: [null, [Validators.required]],
    });
  }

  onSubmit() {
    this.postFile(this.form.getRawValue()).then(() => this.dialogRef.close());
  }

  public fileUpload(event: any) {
    const { files } = event.target || {};

    this.fileChange(files);
  }

  public fileChange(files: File[]) {
    const [file] = files;

    const reader = new FileReader();

    reader.onload = () => {
      const { name, type } = file;
      const src = reader.result;

      this.addFile({
        src,
        name,
        type,
      });
    };

    reader.readAsDataURL(file);
  }

  public removeFile() {
    this.form.patchValue({ file: null });
  }

  private postFile(dataCleanseFile) {
    const endpoint = `${endpoints.user.dataCleanse}/upload`;

    return this.Api.post(
      endpoint,
      dataCleanseFile,
      environment.userAdminUrl
    ).then(
      () => this.Api.handleSuccess('DataCleanse CSV sent'),
      (error) => this.Api.handleError(error)
    );
  }

  private addFile(file: any) {
    this.form.patchValue({ file });
  }
}
